import { render, staticRenderFns } from "./SongSearch.vue?vue&type=template&id=34fd919e&"
import script from "./SongSearch.vue?vue&type=script&lang=js&"
export * from "./SongSearch.vue?vue&type=script&lang=js&"
import style0 from "./SongSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports